import React, { useContext } from "react";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import { useIntl } from "gatsby-plugin-intl";
import get from "lodash/get";

import { GlobalDispatchContext, GlobalStateContext } from "../context";

const StyledWrapper = styled.div`
  margin-right: 1rem;
  position: relative;
  opacity: 0.7;
  transition: opacity 0.3s;
  &:hover {
    cursor: pointer;
    opacity: 1;
  }
`;

const StyledBagIcon = styled.div`
  & img {
  }
`;

const StyledBadge = styled.div`
  position: absolute;
  background-color: ${(props) => props.theme.color.darkCream};
  color: ${(props) => props.theme.color.cream};
  font-size: 0.4rem;
  font-weight: 600;
  bottom: 0.5rem;
  left: 0.5rem;
  padding: 0.1rem 0.25rem;
  border-radius: 2px;
  pointer-events: none;
  ${(props) => props.theme.noSelect}
`;

const BagIcon = ({ color }) => {
  return (
    <StyledBagIcon color={color}>
      <StaticImage
        style={{
          filter: `invert(${color === "black" ? 1 : 0})`,
          width: "0.9rem",
          height: "100%",
        }}
        src={"../../images/Icon/bag.png"}
        alt="Bag"
        imgStyle={{ objectFit: "contain" }}
        placeholder="blurred"
      />
    </StyledBagIcon>
  );
};

export default function BagButton({ color, location, ...props }) {
  const intl = useIntl();
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const { shopifyCheckout } = state;
  const bagFrames = get(shopifyCheckout, "lineItems", []);

  const handleToggleBag = () => {
    dispatch({ type: "TOGGLE_IS_BAG_SHOWN" });
  };
  return (
    <StyledWrapper onClick={() => handleToggleBag()}>
      <BagIcon color={color} />
      {bagFrames.length > 0 && (
        <StyledBadge>
          {bagFrames.reduce((total, frame) => total + frame.quantity, 0)}
        </StyledBadge>
      )}
    </StyledWrapper>
  );
}
